import { useState, useEffect } from "react";

const CustomVsOffShelfDecisionMatrix = () => {
  const [answers, setAnswers] = useState({});
  const [showResults, setShowResults] = useState(false);
  const [scores, setScores] = useState({ custom: 0, offshelf: 0 });
  const [categoryScores, setCategoryScores] = useState({});

  const questions = [
    {
      category: "Business Uniqueness",
      question:
        "How unique are your business processes compared to competitors?",
      options: [
        { label: "Very Standard", custom: 0, offshelf: 5 },
        { label: "Somewhat Unique", custom: 2, offshelf: 3 },
        { label: "Quite Unique", custom: 4, offshelf: 1 },
        { label: "Highly Unique", custom: 5, offshelf: 0 },
      ],
    },
    {
      category: "Budget",
      question: "What's your upfront budget situation?",
      options: [
        { label: "Very Limited", custom: 1, offshelf: 5 },
        { label: "Moderate", custom: 2, offshelf: 4 },
        { label: "Flexible", custom: 4, offshelf: 2 },
        { label: "High Budget", custom: 5, offshelf: 1 },
      ],
    },
    {
      category: "Timeline",
      question: "How quickly do you need a solution?",
      options: [
        { label: "Immediately", custom: 0, offshelf: 5 },
        { label: "1-2 months", custom: 2, offshelf: 4 },
        { label: "3-6 months", custom: 4, offshelf: 2 },
        { label: "6+ months OK", custom: 5, offshelf: 1 },
      ],
    },
    {
      category: "Scalability",
      question: "How much are you planning to scale in the next 3 years?",
      options: [
        { label: "No Growth", custom: 1, offshelf: 5 },
        { label: "10-30% Growth", custom: 2, offshelf: 4 },
        { label: "50-100% Growth", custom: 4, offshelf: 2 },
        { label: "2X+ Growth", custom: 5, offshelf: 1 },
      ],
    },
    {
      category: "Customization Needs",
      question: "How much customization do you need?",
      options: [
        { label: "Minimal", custom: 0, offshelf: 5 },
        { label: "Some tweaks", custom: 2, offshelf: 3 },
        { label: "Heavy custom", custom: 4, offshelf: 1 },
        { label: "100% Custom", custom: 5, offshelf: 0 },
      ],
    },
    {
      category: "Integration",
      question: "How many existing systems need to integrate?",
      options: [
        { label: "None", custom: 1, offshelf: 5 },
        { label: "1-2 systems", custom: 2, offshelf: 4 },
        { label: "3-5 systems", custom: 4, offshelf: 2 },
        { label: "5+ systems", custom: 5, offshelf: 1 },
      ],
    },
    {
      category: "Ownership",
      question: "How important is owning the software IP?",
      options: [
        { label: "Not Important", custom: 0, offshelf: 5 },
        { label: "Somewhat", custom: 2, offshelf: 3 },
        { label: "Very Important", custom: 4, offshelf: 1 },
        { label: "Critical", custom: 5, offshelf: 0 },
      ],
    },
    {
      category: "Technical Team",
      question: "Do you have an internal technical team?",
      options: [
        { label: "No team", custom: 1, offshelf: 5 },
        { label: "Small team", custom: 3, offshelf: 3 },
        { label: "Good team", custom: 4, offshelf: 2 },
        { label: "Strong team", custom: 5, offshelf: 2 },
      ],
    },
    {
      category: "Competitive Advantage",
      question: "How critical is software to your competitive advantage?",
      options: [
        { label: "Not Critical", custom: 0, offshelf: 5 },
        { label: "Somewhat", custom: 2, offshelf: 3 },
        { label: "Very Critical", custom: 4, offshelf: 1 },
        { label: "Core Differentiator", custom: 5, offshelf: 0 },
      ],
    },
    {
      category: "Compliance",
      question: "How strict are your industry compliance requirements?",
      options: [
        { label: "None/Minimal", custom: 1, offshelf: 5 },
        { label: "Standard", custom: 2, offshelf: 4 },
        { label: "Strict", custom: 4, offshelf: 2 },
        { label: "Very Strict", custom: 5, offshelf: 1 },
      ],
    },
    {
      category: "Long-term Vision",
      question: "What's your long-term software strategy?",
      options: [
        { label: "Quick solution", custom: 0, offshelf: 5 },
        { label: "2-3 year plan", custom: 2, offshelf: 4 },
        { label: "5 year plan", custom: 4, offshelf: 2 },
        { label: "10+ year asset", custom: 5, offshelf: 1 },
      ],
    },
    {
      category: "User Count",
      question: "How many users will use this software?",
      options: [
        { label: "1-10 users", custom: 1, offshelf: 5 },
        { label: "11-50 users", custom: 3, offshelf: 4 },
        { label: "51-200 users", custom: 4, offshelf: 2 },
        { label: "200+ users", custom: 5, offshelf: 2 },
      ],
    },
  ];

  const selectOption = (questionIndex, optionIndex) => {
    setAnswers((prev) => ({
      ...prev,
      [questionIndex]: optionIndex,
    }));
  };

  const calculateScore = () => {
    if (Object.keys(answers).length < questions.length) {
      alert("Please answer all questions before calculating!");
      return;
    }

    let customTotal = 0;
    let offshelfTotal = 0;
    let categoryScoresTemp = {};

    questions.forEach((q, index) => {
      const selectedOption = q.options[answers[index]];
      customTotal += selectedOption.custom;
      offshelfTotal += selectedOption.offshelf;

      if (!categoryScoresTemp[q.category]) {
        categoryScoresTemp[q.category] = { custom: 0, offshelf: 0 };
      }
      categoryScoresTemp[q.category].custom += selectedOption.custom;
      categoryScoresTemp[q.category].offshelf += selectedOption.offshelf;
    });

    setScores({ custom: customTotal, offshelf: offshelfTotal });
    setCategoryScores(categoryScoresTemp);
    setShowResults(true);

    setTimeout(() => {
      const resultsElement = document.getElementById("decision-results");
      if (resultsElement) {
        resultsElement.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);
  };

  const resetQuiz = () => {
    setAnswers({});
    setShowResults(false);
    setScores({ custom: 0, offshelf: 0 });
    setCategoryScores({});
  };

  const getRecommendation = () => {
    const { custom, offshelf } = scores;
    const winner = custom > offshelf ? "custom" : "offshelf";
    const percentage = Math.round((Math.max(custom, offshelf) / 60) * 100);

    if (winner === "custom" && custom >= 45) {
      return {
        title: "Custom Software is Your Perfect Match!",
        type: "strong",
        content: `
          <p><strong>Custom software is strongly recommended for your business!</strong></p>
          <p>Your unique needs, scalability requirements, and long-term vision make custom development the ideal choice.</p>
          <p>Key factors pointing to custom:</p>
          <ul>
            <li>Your business processes are too unique for off-the-shelf solutions</li>
            <li>You need complete control and ownership</li>
            <li>Long-term ROI will significantly outweigh initial investment</li>
            <li>Custom solution will become your competitive advantage</li>
          </ul>
          <p><strong>Next Step:</strong> Schedule a discovery call to discuss your custom solution.</p>
        `,
      };
    } else if (winner === "custom" && custom >= 30) {
      return {
        title: "Custom Software is a Good Fit",
        type: "good",
        content: `
          <p><strong>Custom software is a good fit for your business.</strong></p>
          <p>You have several factors pointing toward custom development. Consider:</p>
          <ul>
            <li>Starting with an MVP (Minimum Viable Product) to reduce initial cost</li>
            <li>Phased development approach to spread investment over time</li>
            <li>The long-term benefits of ownership and perfect fit to your needs</li>
          </ul>
          <p><strong>Next Step:</strong> Let's discuss a phased custom development approach.</p>
        `,
      };
    } else if (winner === "offshelf" && offshelf >= 45) {
      return {
        title: "Off-the-Shelf is the Right Choice",
        type: "offshelf",
        content: `
          <p><strong>Off-the-shelf software is the right choice for you right now.</strong></p>
          <p>Your current needs align well with existing solutions. Benefits include:</p>
          <ul>
            <li>Immediate deployment with minimal setup</li>
            <li>Lower upfront investment</li>
            <li>Proven solution with regular updates</li>
            <li>Good support and documentation</li>
          </ul>
          <p><strong>Keep in mind:</strong> As you scale and your needs become more unique, custom software may become more valuable. We can help you migrate when the time is right.</p>
        `,
      };
    } else {
      return {
        title: "Hybrid Approach Recommended",
        type: "hybrid",
        content: `
          <p><strong>You're in a hybrid zone - Consider a mixed approach!</strong></p>
          <p>Your answers suggest that neither pure custom nor pure off-the-shelf is perfect. Consider these options:</p>
          <ul>
            <li><strong>Start with off-the-shelf</strong> for immediate needs, plan custom for future</li>
            <li><strong>Hybrid approach:</strong> Off-the-shelf core + custom integrations/features</li>
            <li><strong>Customized off-the-shelf:</strong> Start with platform, heavily customize</li>
          </ul>
          <p><strong>Next Step:</strong> Let's discuss a hybrid strategy that gives you best of both worlds.</p>
        `,
      };
    }
  };

  const answeredCount = Object.keys(answers).length;
  const totalQuestions = questions.length;
  const progressPercentage = (answeredCount / totalQuestions) * 100;

  useEffect(() => {
    document.title =
      "Custom vs Off-Shelf Software Decision Matrix | Plural Code Technologies";
  }, []);

  return (
    <div className="decision-matrix-page">
      {/* Hero Section - Matching Home Page Design */}
      <section className="decision-hero">
        <div className="container">
          <div className="hero-content">
            <div className="hero-badge">
              <span className="badge-icon">⚖️</span>
              <span className="badge-text">DECISION MATRIX</span>
            </div>
            <h1 className="hero-title">
              Custom vs <span className="highlight">Off-Shelf</span> Software
              Decision Matrix
            </h1>
            <p className="hero-subtitle">
              Answer 12 strategic questions to find your perfect software
              solution. Get data-driven recommendations tailored to your
              business needs.
            </p>
            <div className="hero-stats">
              <div className="stat-item">
                <div className="stat-value">92%</div>
                <div className="stat-label">Accuracy Rate</div>
              </div>
              <div className="stat-item">
                <div className="stat-value">12</div>
                <div className="stat-label">Strategic Questions</div>
              </div>
              <div className="stat-item">
                <div className="stat-value">5min</div>
                <div className="stat-label">Completion Time</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="container main-content">
        {/* Progress Bar */}
        <div className="progress-section">
          <div className="progress-header">
            <h2>Your Decision Matrix</h2>
            <p>
              Answer all questions to unlock your personalized recommendation
            </p>
          </div>
          <div className="progress-bar">
            <div
              className="progress-fill"
              style={{ width: `${progressPercentage}%` }}
            />
            <div className="progress-text">
              <span>
                Progress: {answeredCount}/{totalQuestions} questions answered
              </span>
              <span>{Math.round(progressPercentage)}% Complete</span>
            </div>
          </div>
        </div>

        {/* Instructions */}
        <div className="instructions-card">
          <div className="instructions-header">
            <div className="instructions-icon">📋</div>
            <div>
              <h3>How This Decision Matrix Works</h3>
              <p>
                Rate each factor based on your business needs to get
                personalized recommendations
              </p>
            </div>
          </div>
          <div className="instructions-grid">
            <div className="instruction-item">
              <div className="instruction-icon">🎯</div>
              <div className="instruction-content">
                <h4>Strategic Assessment</h4>
                <p>
                  12 key factors that determine software fit for your business
                </p>
              </div>
            </div>
            <div className="instruction-item">
              <div className="instruction-icon">📊</div>
              <div className="instruction-content">
                <h4>Data-Driven Results</h4>
                <p>Algorithm calculates scores based on industry benchmarks</p>
              </div>
            </div>
            <div className="instruction-item">
              <div className="instruction-icon">💡</div>
              <div className="instruction-content">
                <h4>Personalized Recommendations</h4>
                <p>Actionable insights tailored to your specific situation</p>
              </div>
            </div>
          </div>
        </div>

        {/* Questions Section */}
        <div className="questions-section">
          {questions.map((q, index) => (
            <div className="question-card" key={index}>
              <div className="question-header">
                <div className="question-meta">
                  <span className="question-category">{q.category}</span>
                  <span className="question-number">
                    Question {index + 1} of {totalQuestions}
                  </span>
                </div>
                <h3 className="question-text">{q.question}</h3>
              </div>

              <div className="options-grid">
                {q.options.map((option, optIndex) => (
                  <button
                    key={optIndex}
                    className={`option-btn ${answers[index] === optIndex ? "selected" : ""}`}
                    onClick={() => selectOption(index, optIndex)}
                  >
                    <div className="option-content">
                      <span className="option-label">{option.label}</span>
                      <div className="option-scores">
                        <span className="score-badge custom">
                          Custom: {option.custom}
                        </span>
                        <span className="score-badge offshelf">
                          Off-shelf: {option.offshelf}
                        </span>
                      </div>
                    </div>
                    {answers[index] === optIndex && (
                      <div className="option-selected">✓ Selected</div>
                    )}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Calculate Button */}
        <div className="calculate-section">
          <button
            className="calculate-btn"
            onClick={calculateScore}
            disabled={answeredCount < totalQuestions}
          >
            <span className="btn-icon">🎯</span>
            <span className="btn-text">Get My Personalized Recommendation</span>
            <span className="btn-arrow">→</span>
          </button>
          {answeredCount < totalQuestions && (
            <p className="calculate-note">
              Please answer all {totalQuestions} questions to see your results
            </p>
          )}
        </div>

        {/* Results Section */}
        {showResults && (
          <div className="results-section" id="decision-results">
            {/* Results Header */}
            <div className="results-header">
              <div className="results-badge">
                <span className="badge-icon">📊</span>
                <span className="badge-text">YOUR RESULTS</span>
              </div>
              <h2>Your Software Decision Analysis</h2>
              <p>
                Based on your answers, here's our data-driven recommendation
              </p>
            </div>

            {/* Score Comparison */}
            <div className="score-comparison">
              <div className="score-card custom">
                <div className="score-header">
                  <div className="score-icon">✨</div>
                  <h3>Custom Software</h3>
                </div>
                <div className="score-body">
                  <div className="score-value">{scores.custom}</div>
                  <div className="score-max">out of 60 points</div>
                  <div className="score-percentage">
                    {Math.round((scores.custom / 60) * 100)}% Match
                  </div>
                </div>
              </div>

              <div className="vs-divider">
                <div className="vs-circle">VS</div>
              </div>

              <div className="score-card offshelf">
                <div className="score-header">
                  <div className="score-icon">📦</div>
                  <h3>Off-the-Shelf</h3>
                </div>
                <div className="score-body">
                  <div className="score-value">{scores.offshelf}</div>
                  <div className="score-max">out of 60 points</div>
                  <div className="score-percentage">
                    {Math.round((scores.offshelf / 60) * 100)}% Match
                  </div>
                </div>
              </div>
            </div>

            {/* Winner Announcement */}
            <div className={`winner-announcement ${getRecommendation().type}`}>
              <div className="winner-content">
                <div className="winner-icon">🏆</div>
                <div className="winner-text">
                  <h3>{getRecommendation().title}</h3>
                  <p>
                    {scores.custom > scores.offshelf
                      ? "Custom software"
                      : "Off-the-shelf software"}{" "}
                    scored {Math.abs(scores.custom - scores.offshelf)} points
                    higher for your business needs
                  </p>
                </div>
              </div>
            </div>

            {/* Category Breakdown */}
            <div className="category-breakdown">
              <h3>📊 Category-by-Category Analysis</h3>
              <p>See how each factor contributed to your scores</p>

              <div className="breakdown-grid">
                {Object.entries(categoryScores).map(([category, scores]) => (
                  <div className="breakdown-item" key={category}>
                    <div className="breakdown-header">
                      <span className="breakdown-category">{category}</span>
                      <span className="breakdown-winner">
                        {scores.custom > scores.offshelf
                          ? "Custom"
                          : "Off-shelf"}{" "}
                        Leads
                      </span>
                    </div>
                    <div className="breakdown-bars">
                      <div className="score-bar custom">
                        <div
                          className="bar-fill"
                          style={{ width: `${(scores.custom / 5) * 100}%` }}
                        />
                        <span className="bar-label">{scores.custom}</span>
                      </div>
                      <div className="score-bar offshelf">
                        <div
                          className="bar-fill"
                          style={{ width: `${(scores.offshelf / 5) * 100}%` }}
                        />
                        <span className="bar-label">{scores.offshelf}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Recommendation */}
            <div className="recommendation-card">
              <div className="recommendation-header">
                <div className="recommendation-icon">💡</div>
                <h3>Personalized Recommendation & Next Steps</h3>
              </div>
              <div
                className="recommendation-content"
                dangerouslySetInnerHTML={{
                  __html: getRecommendation().content,
                }}
              />
              <div className="recommendation-actions">
                <button
                  className="action-btn primary"
                  onClick={() => window.open("/contact", "_blank")}
                >
                  <span>📞 Schedule Free Consultation</span>
                  <span>→</span>
                </button>
                <button className="action-btn secondary" onClick={resetQuiz}>
                  <span>🔄 Take Assessment Again</span>
                  <span>↻</span>
                </button>
              </div>
            </div>

            {/* Additional Resources */}
            <div className="resources-section">
              <h3>Additional Resources</h3>
              <div className="resources-grid">
                <div className="resource-card">
                  <div className="resource-icon">🧮</div>
                  <div className="resource-content">
                    <h4>ROI Calculator</h4>
                    <p>
                      Calculate the exact financial impact of custom vs
                      off-the-shelf software
                    </p>
                  </div>
                  <button
                    className="resource-btn"
                    onClick={() => window.open("/lm/roi-calculator", "_blank")}
                  >
                    Calculate ROI →
                  </button>
                </div>
                <div className="resource-card">
                  <div className="resource-icon">📚</div>
                  <div className="resource-content">
                    <h4>Case Studies</h4>
                    <p>
                      See how businesses similar to yours made their software
                      decisions
                    </p>
                  </div>
                  <button
                    className="resource-btn"
                    onClick={() => window.open("/case-studies", "_blank")}
                  >
                    View Cases →
                  </button>
                </div>
                <div className="resource-card">
                  <div className="resource-icon">📞</div>
                  <div className="resource-content">
                    <h4>Expert Consultation</h4>
                    <p>30-minute strategy call with our software architects</p>
                  </div>
                  <button
                    className="resource-btn"
                    onClick={() => window.open("/contact", "_blank")}
                  >
                    Book Call →
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <style jsx>{`
        .decision-matrix-page {
          font-family:
            -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
          background: linear-gradient(180deg, #ffffff 0%, #f8faff 100%);
          min-height: 100vh;
        }

        /* Hero Section - Matching Home Page */
        .decision-hero {
          background: linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%);
          color: white;
          padding: 80px 0 60px;
          position: relative;
          overflow: hidden;
        }

        .decision-hero::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background:
            radial-gradient(
              circle at 20% 80%,
              rgba(255, 215, 0, 0.1) 0%,
              transparent 50%
            ),
            radial-gradient(
              circle at 80% 20%,
              rgba(255, 255, 255, 0.05) 0%,
              transparent 50%
            );
        }

        .hero-content {
          max-width: 800px;
          margin: 0 auto;
          text-align: center;
          position: relative;
          z-index: 1;
          padding: 0 20px;
        }

        .hero-badge {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(10px);
          padding: 8px 16px;
          border-radius: 50px;
          margin-bottom: 24px;
          border: 1px solid rgba(255, 255, 255, 0.2);
        }

        .badge-icon {
          font-size: 20px;
        }

        .badge-text {
          font-size: 14px;
          font-weight: 600;
          letter-spacing: 1px;
        }

        .hero-title {
          font-size: clamp(2.5rem, 5vw, 3.5rem);
          font-weight: 700;
          line-height: 1.1;
          margin-bottom: 20px;
        }

        .highlight {
          background: linear-gradient(90deg, #ffd700 0%, #ffec8b 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .hero-subtitle {
          font-size: 1.25rem;
          line-height: 1.6;
          color: rgba(255, 255, 255, 0.9);
          max-width: 600px;
          margin: 0 auto 40px;
        }

        .hero-stats {
          display: flex;
          justify-content: center;
          gap: 40px;
          flex-wrap: wrap;
        }

        .stat-item {
          text-align: center;
          min-width: 120px;
        }

        .stat-value {
          font-size: 2.5rem;
          font-weight: 700;
          color: #ffd700;
          margin-bottom: 4px;
        }

        .stat-label {
          font-size: 0.875rem;
          color: rgba(255, 255, 255, 0.8);
          text-transform: uppercase;
          letter-spacing: 1px;
        }

        /* Main Content */
        .container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 20px;
        }

        .main-content {
          padding: 60px 20px;
        }

        /* Progress Section */
        .progress-section {
          margin-bottom: 40px;
        }

        .progress-header {
          text-align: center;
          margin-bottom: 30px;
        }

        .progress-header h2 {
          font-size: 2rem;
          color: #0a2458;
          margin-bottom: 8px;
        }

        .progress-header p {
          color: #0a2458;
          font-size: 1.125rem;
        }

        .progress-bar {
          background: #f1f5f9;
          height: 12px;
          border-radius: 6px;
          overflow: hidden;
          margin-bottom: 12px;
          position: relative;
        }

        .progress-fill {
          background: linear-gradient(90deg, #0a2458, #1a3b8a);
          height: 100%;
          border-radius: 6px;
          transition: width 0.3s ease;
        }

        .progress-text {
          display: flex;
          justify-content: space-between;
          font-size: 0.875rem;
          color: #64748b;
          font-weight: 500;
        }

        /* Instructions Card */
        .instructions-card {
          background: linear-gradient(
            135deg,
            rgba(10, 36, 88, 0.05) 0%,
            rgba(255, 215, 0, 0.05) 100%
          );
          border-radius: 20px;
          padding: 32px;
          margin-bottom: 40px;
          border: 1px solid rgba(10, 36, 88, 0.1);
        }

        .instructions-header {
          display: flex;
          align-items: center;
          gap: 16px;
          margin-bottom: 30px;
        }

        .instructions-icon {
          font-size: 32px;
          width: 60px;
          height: 60px;
          background: rgba(10, 36, 88, 0.1);
          border-radius: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .instructions-header h3 {
          font-size: 1.5rem;
          color: #0a2458;
          margin-bottom: 4px;
        }

        .instructions-header p {
          color: #0a2458;
          margin: 0;
        }

        .instructions-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 24px;
        }

        .instruction-item {
          display: flex;
          align-items: flex-start;
          gap: 16px;
        }

        .instruction-icon {
          font-size: 24px;
          width: 48px;
          height: 48px;
          background: white;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
        }

        .instruction-content h4 {
          font-size: 1.125rem;
          color: #0a2458;
          margin-bottom: 4px;
        }

        .instruction-content p {
          color: #64748b;
          font-size: 0.875rem;
          margin: 0;
          line-height: 1.5;
        }

        /* Questions Section */
        .questions-section {
          display: flex;
          flex-direction: column;
          gap: 24px;
          margin-bottom: 40px;
        }

        .question-card {
          background: white;
          border-radius: 16px;
          padding: 32px;
          box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
          border: 1px solid #f1f5f9;
          transition: all 0.3s ease;
        }

        .question-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
        }

        .question-header {
          margin-bottom: 24px;
        }

        .question-meta {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 12px;
        }

        .question-category {
          background: rgba(10, 36, 88, 0.1);
          color: #0a2458;
          padding: 6px 12px;
          border-radius: 20px;
          font-size: 0.875rem;
          font-weight: 600;
        }

        .question-number {
          color: #64748b;
          font-size: 0.875rem;
          font-weight: 500;
        }

        .question-text {
          font-size: 1.25rem;
          color: #0a2458;
          line-height: 1.4;
          margin: 0;
        }

        .options-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 16px;
        }

        .option-btn {
          background: white;
          border: 2px solid #e2e8f0;
          border-radius: 12px;
          padding: 20px;
          cursor: pointer;
          transition: all 0.2s ease;
          text-align: left;
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .option-btn:hover {
          border-color: #94a3b8;
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }

        .option-btn.selected {
          border-color: #0a2458;
          background: linear-gradient(
            135deg,
            rgba(10, 36, 88, 0.05) 0%,
            rgba(10, 36, 88, 0.02) 100%
          );
        }

        .option-content {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 16px;
        }

        .option-label {
          font-size: 1rem;
          font-weight: 600;
          color: #0a2458;
          flex: 1;
        }

        .option-scores {
          display: flex;
          flex-direction: column; 
          gap: 8px;
        }

        .score-badge {
          font-size: 0.75rem;
          padding: 4px 8px;
          border-radius: 4px;
          font-weight: 600;
        }

        .score-badge.custom {
          background: rgba(37, 99, 235, 0.1);
          color: #2563eb;
        }

        .score-badge.offshelf {
          background: rgba(239, 68, 68, 0.1);
          color: #ef4444;
        }

        .option-selected {
          color: #10b981;
          font-size: 0.875rem;
          font-weight: 600;
          display: flex;
          align-items: center;
          gap: 6px;
        }

        /* Calculate Button */
        .calculate-section {
          text-align: center;
          margin: 60px 0;
        }

        .calculate-btn {
          background: linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%);
          color: white;
          border: none;
          padding: 20px 48px;
          font-size: 1.25rem;
          font-weight: 600;
          border-radius: 16px;
          display: inline-flex;
          align-items: center;
          gap: 12px;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 10px 30px rgba(10, 36, 88, 0.2);
        }

        .calculate-btn:hover:not(:disabled) {
          transform: translateY(-3px);
          box-shadow: 0 15px 40px rgba(10, 36, 88, 0.3);
        }

        .calculate-btn:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        .calculate-note {
          color: #64748b;
          font-size: 0.875rem;
          margin-top: 12px;
        }

        /* Results Section */
        .results-section {
          animation: fadeIn 0.6s ease;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .results-header {
          text-align: center;
          margin-bottom: 60px;
        }

        .results-badge {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: rgba(10, 36, 88, 0.1);
          padding: 8px 16px;
          border-radius: 50px;
          margin-bottom: 24px;
          border: 1px solid rgba(10, 36, 88, 0.2);
        }

        .results-header h2 {
          font-size: 2.5rem;
          color: #0a2458;
          margin-bottom: 12px;
        }

        .results-header p {
          color: #0a2458;
          font-size: 1.125rem;
          max-width: 600px;
          margin: 0 auto;
        }

        /* Score Comparison */
        .score-comparison {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 40px;
          margin-bottom: 60px;
          flex-wrap: wrap;
        }

        .score-card {
          flex: 1;
          min-width: 300px;
          background: white;
          border-radius: 20px;
          padding: 40px;
          text-align: center;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
        }

        .score-card.custom {
          border-top: 6px solid #2563eb;
        }

        .score-card.offshelf {
          border-top: 6px solid #ef4444;
        }

        .score-header {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 12px;
          margin-bottom: 24px;
        }

        .score-icon {
          font-size: 32px;
          width: 60px;
          height: 60px;
          background: rgba(37, 99, 235, 0.1);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .score-card.offshelf .score-icon {
          background: rgba(239, 68, 68, 0.1);
        }

        .score-header h3 {
          font-size: 1.5rem;
          color: #0a2458;
          margin: 0;
        }

        .score-body {
          margin-top: 20px;
        }

        .score-value {
          font-size: 4rem;
          font-weight: 700;
          margin-bottom: 8px;
        }

        .score-card.custom .score-value {
          color: #2563eb;
        }

        .score-card.offshelf .score-value {
          color: #ef4444;
        }

        .score-max {
          color: #64748b;
          font-size: 1rem;
          margin-bottom: 16px;
        }

        .score-percentage {
          font-size: 1.125rem;
          font-weight: 600;
          color: #0a2458;
          padding: 8px 16px;
          background: rgba(10, 36, 88, 0.05);
          border-radius: 20px;
          display: inline-block;
        }

        .vs-divider {
          position: relative;
          min-width: 100px;
          text-align: center;
        }

        .vs-circle {
          width: 60px;
          height: 60px;
          background: #0a2458;
          color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 700;
          font-size: 0.875rem;
          margin: 0 auto;
        }

        /* Winner Announcement */
        .winner-announcement {
          border-radius: 20px;
          padding: 40px;
          margin-bottom: 60px;
        }

        .winner-announcement.strong {
          background: linear-gradient(135deg, #10b981 0%, #34d399 100%);
        }

        .winner-announcement.good {
          background: linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%);
        }

        .winner-announcement.offshelf {
          background: linear-gradient(135deg, #ef4444 0%, #f87171 100%);
        }

        .winner-announcement.hybrid {
          background: linear-gradient(135deg, #8b5cf6 0%, #a78bfa 100%);
        }

        .winner-content {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 24px;
          color: white;
          text-align: center;
        }

        .winner-icon {
          font-size: 48px;
          flex-shrink: 0;
        }

        .winner-text h3 {
          font-size: 2rem;
          margin-bottom: 8px;
        }

        .winner-text p {
          font-size: 1.125rem;
          opacity: 0.95;
          margin: 0;
        }

        /* Category Breakdown */
        .category-breakdown {
          background: white;
          border-radius: 20px;
          padding: 40px;
          margin-bottom: 60px;
          box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
        }

        .category-breakdown h3 {
          font-size: 1.75rem;
          color: #0a2458;
          margin-bottom: 8px;
        }

        .category-breakdown p {
          color: #64748b;
          margin-bottom: 32px;
        }

        .breakdown-grid {
          display: flex;
          flex-direction: column;
          gap: 20px;
        }

        .breakdown-item {
          background: #f8fafc;
          border-radius: 12px;
          padding: 20px;
        }

        .breakdown-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 16px;
        }

        .breakdown-category {
          font-weight: 600;
          color: #0a2458;
          font-size: 1.125rem;
        }

        .breakdown-winner {
          font-size: 0.875rem;
          font-weight: 600;
          padding: 4px 12px;
          border-radius: 20px;
          background: rgba(37, 99, 235, 0.1);
          color: #2563eb;
        }

        .breakdown-bars {
          display: flex;
          gap: 16px;
        }

        .score-bar {
          flex: 1;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .bar-fill {
          height: 12px;
          border-radius: 6px;
          transition: width 0.6s ease;
        }

        .score-bar.custom .bar-fill {
          background: linear-gradient(90deg, #2563eb, #3b82f6);
        }

        .score-bar.offshelf .bar-fill {
          background: linear-gradient(90deg, #ef4444, #f87171);
        }

        .bar-label {
          font-weight: 600;
          font-size: 0.875rem;
          min-width: 20px;
        }

        .score-bar.custom .bar-label {
          color: #2563eb;
        }

        .score-bar.offshelf .bar-label {
          color: #ef4444;
        }

        /* Recommendation Card */
        .recommendation-card {
          background: linear-gradient(
            135deg,
            rgba(10, 36, 88, 0.05) 0%,
            rgba(10, 36, 88, 0.02) 100%
          );
          border-radius: 20px;
          padding: 40px;
          margin-bottom: 60px;
          border: 1px solid rgba(10, 36, 88, 0.1);
        }

        .recommendation-header {
          display: flex;
          align-items: center;
          gap: 16px;
          margin-bottom: 32px;
        }

        .recommendation-icon {
          font-size: 32px;
          width: 60px;
          height: 60px;
          background: rgba(10, 36, 88, 0.1);
          border-radius: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .recommendation-header h3 {
          font-size: 1.75rem;
          color: #0a2458;
          margin: 0;
        }

        .recommendation-content {
          font-size: 1.125rem;
          line-height: 1.8;
          color: #374151;
          margin-bottom: 40px;
        }

        .recommendation-content strong {
          color: #0a2458;
        }

        .recommendation-content ul {
          margin-left: 20px;
          margin-top: 16px;
        }

        .recommendation-content li {
          margin-bottom: 8px;
        }

        .recommendation-actions {
          display: flex;
          gap: 16px;
          flex-wrap: wrap;
        }

        .action-btn {
          flex: 1;
          padding: 20px 32px;
          border-radius: 12px;
          font-weight: 600;
          display: flex;
          align-items: center;
          justify-content: space-between;
          cursor: pointer;
          transition: all 0.3s ease;
          min-width: 250px;
          border: none;
          font-size: 1rem;
        }

        .action-btn.primary {
          background: linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%);
          color: white;
        }

        .action-btn.primary:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 25px rgba(10, 36, 88, 0.3);
        }

        .action-btn.secondary {
          background: transparent;
          color: #0a2458;
          border: 2px solid #0a2458;
        }

        .action-btn.secondary:hover {
          background: rgba(10, 36, 88, 0.05);
        }

        /* Resources Section */
        .resources-section {
          margin-top: 80px;
        }

        .resources-section h3 {
          font-size: 1.75rem;
          color: #0a2458;
          margin-bottom: 32px;
          text-align: center;
        }

        .resources-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 24px;
        }

        .resource-card {
          background: white;
          border-radius: 16px;
          padding: 32px;
          box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
          display: flex;
          flex-direction: column;
          gap: 20px;
        }

        .resource-icon {
          font-size: 32px;
          width: 64px;
          height: 64px;
          background: rgba(10, 36, 88, 0.1);
          border-radius: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .resource-content h4 {
          font-size: 1.25rem;
          color: #0a2458;
          margin-bottom: 8px;
        }

        .resource-content p {
          color: #64748b;
          margin: 0;
          line-height: 1.6;
        }

        .resource-btn {
          background: transparent;
          color: #0a2458;
          border: 2px solid #0a2458;
          padding: 12px 24px;
          border-radius: 8px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          text-align: center;
          margin-top: auto;
        }

        .resource-btn:hover {
          background: rgba(10, 36, 88, 0.05);
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          .hero-title {
            font-size: 2.25rem;
          }

          .hero-subtitle {
            font-size: 1.125rem;
          }

          .hero-stats {
            gap: 20px;
          }

          .stat-item {
            min-width: 100px;
          }

          .options-grid {
            grid-template-columns: 1fr;
          }

          .score-comparison {
            flex-direction: column;
            gap: 20px;
          }

          .vs-divider {
            min-width: auto;
            order: -1;
          }

          .winner-content {
            flex-direction: column;
            text-align: center;
          }

          .recommendation-actions {
            flex-direction: column;
          }

          .action-btn {
            min-width: 100%;
          }

          .resources-grid {
            grid-template-columns: 1fr;
          }
        }

        @media (max-width: 480px) {
          .question-card {
            padding: 24px;
          }

          .question-text {
            font-size: 1.125rem;
          }

          .option-content {
            flex-direction: column;
            align-items: flex-start;
            gap: 8px;
          }

          .score-card {
            min-width: 100%;
            padding: 30px 20px;
          }

          .score-value {
            font-size: 3rem;
          }
        }
      `}</style>
    </div>
  );
};

export default CustomVsOffShelfDecisionMatrix;
